import { createContext } from 'react';
export const RenderBeaconContext = createContext({
    setReady: () => undefined,
    isTimeout: false,
});
